module.exports = __webpack_public_path__ + "img/g1.5e283e56.jpg";